import React from 'react';
import { Link, browserHistory } from 'react-router';
import { Checkbox, Button } from '@blueprintjs/core';
import { User } from 'api';
import { connect } from 'react-redux';
import cookie from 'react-cookie';
import { Toastr } from 'modules/toastr';
import { msg } from "constants/message";
import { checkEmail } from 'base/lib/validate';
import { CheckPermission } from 'modules/login/CheckPermission';
import { API_URL_SSO, CLIENT_ID, REDIRECT_URI } from 'constants/config';
import { get } from 'lodash';
let loginBg = require('assets/images/bannerLogin.png');

class Login extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      Username: '',
      Password: '',
      ghiNho: false,
      loading: false,
      isSubmit: false,
      emailValid: true
    }
  }
  // componentWillMount() {
  //   if (typeof cookie.load('accessToken') == 'undefined') {
  //     if (!sessionStorage.getItem("checkLoginGov")) {
  //       sessionStorage.setItem("checkLoginGov", true);
  //       window.location.replace('http://dev.api.thanhtratp.greenglobal.vn:8088/cas/login');
  //     }
  //   }
  // }
  componentDidMount() {
    if (typeof cookie.load('accessToken') !== 'undefined') {
      browserHistory.push('/');
    }

    if (this.props.route.type == 'SSO' && typeof cookie.load('SESSION') !== 'undefined') {
      cookie.remove('SESSION', { path: '/' })
      this.handleLoginSSO();
    }
    if (this.props.route.type == 'SSOERR') {
      this.clearAllCookie();
    }
  }

  clearAllCookie() {
    document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
  }

  handleChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
      isSubmit: false,
      emailValid: true
    });
  }
  handleLogin(e) {
    e.preventDefault();
    if (this.handleValidate()) {
      let params = {
        Email: this.state.Username.trim(),
        Password: this.state.Password
      }
      this.setState({ loading: true });
      User.actions.signin.request(null, params).then(res => {
        if (res && res.data) {
          localStorage.clear();
          let userData = {
            id: res.data.congChucId,
            name: res.data.hoVaTen,
            chucVu: res.data.chucVu,
            tenVaiTro: res.data.tenVaiTro,
            coQuanQuanLyId: res.data.coQuanQuanLyId,
            vaiTroMacDinhId: res.data.vaiTroMacDinhId,
            loaiVaiTroMacDinh: res.data.loaiVaiTroMacDinh,
            roles: [],
            quyenBatDauQuyTrinh: res.data.quyenBatDauQuyTrinh,
            donViId: res.data.donViId,
            donViChaId: res.data.donViChaId,
            tenCoQuanQuanLy: res.data.tenCoQuanQuanLy,
            capCoQuanQuanLyId: res.data.capCoQuanQuanLyId,
            capCoQuanQuanLyCuaDonViId: res.data.capCoQuanQuanLyCuaDonViId,
            capCoQuanQuanLyCuaDonViChaId: res.data.capCoQuanQuanLyCuaDonViChaId,
            isBoSungThongTin: res.data.isBoSungThongTin
          }
          res.data.roles.map((item, i) => {
            userData.roles.push({
              loaiVaiTro: item.loaiVaiTro,
              vaiTroId: item.vaiTroId,
              ten: item.ten,
              quyen: item.quyen
            });
          });
          let expiresParams = { path: '/' };
          if (this.state.ghiNho) {
            expiresParams = { path: '/', maxAge: 3600 * 24 * 365 };
          }
          cookie.save('accessToken', res.data.token, expiresParams);
          localStorage.setItem('userInfo', JSON.stringify(userData));
          this.props.dispatch({
            type: 'INIT_DULIEU',
            value: true
          });
          CheckPermission('GIAM_SAT_TRA_CUU_LIETKE') ? browserHistory.push('/giam-sat-tra-cuu') : browserHistory.push('/');
          const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
          const TTTW = 19;
          if (get(userInfo, 'capCoQuanQuanLyId') === TTTW) {
            browserHistory.push('/thanh-tra');
          }
          if (get(userInfo, 'loaiVaiTroMacDinh') === 'NHAP_LIEU_DON_CU') {
            browserHistory.push('/xu-ly-don-cu');
          }
        }
      }).catch((error) => {
        setTimeout(() => {
          this.setState({ loading: false });
          if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
        }, 1000);
      });
    }
  }

  handleValidate() {
    this.setState({ isSubmit: true });
    let pass = true;
    if (!this.state.Username) {
      pass = false;
    } else if (!checkEmail(this.state.Username.trim())) {
      pass = false;
      this.setState({ emailValid: false });
    } else if (!this.state.Password) {
      pass = false;
    }
    return pass;
  }

  handleCheck(e) {
    this.setState({
      ghiNho: !this.state.ghiNho
    });
  }

  handleLoginSSO() {
    window.location.href = `${API_URL_SSO}?client_id=${CLIENT_ID}&response_type=code&scope=openid&state=true&redirect_uri=${REDIRECT_URI}`;
  }

  changePage(name) {
    browserHistory.push(name);
  }

  render() {
    let logoImg = require('assets/images/logo-login.png');
    return (
      <div className="login" style={{ backgroundImage: `url(${loginBg})` }}>
        <div className="login-block">
          <h1 className="logo-login">
            <img src={logoImg} alt="" className="login-logo-image" />
            <span className="login-logo-caption">Phần mềm và xây dựng cơ sở dữ liệu hoạt động thanh tra trên địa bàn Tỉnh Quảng Ngãi</span>
          </h1>
          {
            this.props.route.type == 'NORMAL' &&
            <form className="login-form" onSubmit={this.handleLogin.bind(this)}>
              <h2 className="title-login txt-blue">Đăng nhập</h2>
              <div className="login-group">
                <span className="tt-login-mail"></span>
                <input className={`login-input pt-input ${this.state.isSubmit && !this.state.Username ? 'pt-intent-danger' : ''}`}
                  type="text" placeholder="Địa chỉ thư điện tử" name="Username" value={this.state.Username}
                  onChange={this.handleChange.bind(this)} autoFocus autoComplete="off"
                  maxLength={40} />
                {
                  this.state.isSubmit && !this.state.Username ?
                    <div className="pt-form-helper-text">{msg.messageDefault}</div>
                    : null
                }
                {
                  this.state.isSubmit && !this.state.emailValid ?
                    <div className="pt-form-helper-text">{msg.emailInvalid}</div>
                    : null
                }
              </div>
              <div className="login-group mb20">
                <span className="tt-login-password"></span>
                <input className={`login-input pt-input ${this.state.isSubmit && !this.state.Password ? 'pt-intent-danger' : ''}`}
                  type="password" placeholder="Mật khẩu" name="Password" value={this.state.Password}
                  onChange={this.handleChange.bind(this)} autoComplete="off"
                  maxLength={40} />
                {
                  this.state.isSubmit && !this.state.Password ?
                    <div className="pt-form-helper-text">{msg.messageDefault}</div>
                    : null
                }
              </div>
              <div className="login-group group-space-between">
                <Checkbox className="pt-large" name="ghiNho" checked={this.state.ghiNho} onChange={this.handleCheck.bind(this)}>
                  <span className="span-checkbox">Ghi nhớ</span>
                </Checkbox>
                <Link to="quen-mat-khau" className="forgot-password"> Quên mật khẩu? </Link>
              </div>
              <div className="login-group">
                <Button type="submit" className={`btn-login ${this.state.loading ? 'btn-loading-inline' : ''}`} text="Đăng nhập" />
              </div>
              <div className="login-group">
                <Button type="button" className='btn-login' onClick={this.handleLoginSSO.bind(this)} text="Đăng nhập SSO" />
              </div>
            </form>
          }
          <div className='bottom-content'>
            <a
              href="https://tinnhiemmang.vn/danh-ba-tin-nhiem/quanlythanhtraquangngaigovvn-1710902160"
              title="Chung nhan Tin Nhiem Mang" target="_blank" rel="noreferrer"
            >
              <img src="https://tinnhiemmang.vn/handle_cert?id=quanlythanhtra.quangngai.gov.vn" width="150px" height="auto" alt="Chung nhan Tin Nhiem Mang" />
            </a>
          </div>
          {/* {
            this.props.route.type == 'SSO' &&
              <div className="logo-login">
                <Button type="button" className='col-input btn-login' style={{width: '170px'}} onClick={this.handleLoginSSO.bind(this)} text="Đăng nhập" />
              </div>
          }
          {
            this.props.route.type == 'SSOERR' &&
            <div className="logo-login">
              <span className="sso-err">Tài khoản của bạn hiện không tồn tại trong hệ thống Thanh tra tỉnh. Vui lòng liên hệ với cán bộ CNTT của cơ quan, đơn vị mình để hỗ trợ thiết lập tài khoản và phân quyền sử dụng hoặc gọi số Hotline của Thanh tra tỉnh:  0255 3824 185</span>
              <Button type="button" className='col-input btn-login mt20' style={{width: '150px'}} onClick={this.changePage.bind(this, '/dang-nhap')} text="Quay về" />
            </div>
          } */}
        </div>
      </div>
    );
  }
}

export default connect()(Login);



// WEBPACK FOOTER //
// ./src/components/modules/login/Login.jsx